(function (global){
'use strict';

var angular = (typeof window !== "undefined" ? window['angular'] : typeof global !== "undefined" ? global['angular'] : null);

/**
 * @ngInject
 */
 function AccountController($scope, $uibModal) {

  $scope.animationsEnabled = true;

  $scope.openModal = function ($event, _url) {

    var modalInstance = $uibModal.open({
      animation: $scope.animationsEnabled,
      templateUrl: _url,
      controller: 'ModalInstanceController',
      resolve: null
    });

    $event.stopPropagation();
    $event.preventDefault();

  };

}
AccountController.$inject = ["$scope", "$uibModal"];

module.exports = AccountController;
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9BcHBCdW5kbGUvUmVzb3VyY2VzL3NjcmlwdHMvYXBwL21vZHVsZXMvdmlldy9jb250cm9sbGVyL2FjY291bnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbIid1c2Ugc3RyaWN0JztcblxudmFyIGFuZ3VsYXIgPSAodHlwZW9mIHdpbmRvdyAhPT0gXCJ1bmRlZmluZWRcIiA/IHdpbmRvd1snYW5ndWxhciddIDogdHlwZW9mIGdsb2JhbCAhPT0gXCJ1bmRlZmluZWRcIiA/IGdsb2JhbFsnYW5ndWxhciddIDogbnVsbCk7XG5cbi8qKlxuICogQG5nSW5qZWN0XG4gKi9cbiBmdW5jdGlvbiBBY2NvdW50Q29udHJvbGxlcigkc2NvcGUsICR1aWJNb2RhbCkge1xuXG4gICRzY29wZS5hbmltYXRpb25zRW5hYmxlZCA9IHRydWU7XG5cbiAgJHNjb3BlLm9wZW5Nb2RhbCA9IGZ1bmN0aW9uICgkZXZlbnQsIF91cmwpIHtcblxuICAgIHZhciBtb2RhbEluc3RhbmNlID0gJHVpYk1vZGFsLm9wZW4oe1xuICAgICAgYW5pbWF0aW9uOiAkc2NvcGUuYW5pbWF0aW9uc0VuYWJsZWQsXG4gICAgICB0ZW1wbGF0ZVVybDogX3VybCxcbiAgICAgIGNvbnRyb2xsZXI6ICdNb2RhbEluc3RhbmNlQ29udHJvbGxlcicsXG4gICAgICByZXNvbHZlOiBudWxsXG4gICAgfSk7XG5cbiAgICAkZXZlbnQuc3RvcFByb3BhZ2F0aW9uKCk7XG4gICAgJGV2ZW50LnByZXZlbnREZWZhdWx0KCk7XG5cbiAgfTtcblxufVxuQWNjb3VudENvbnRyb2xsZXIuJGluamVjdCA9IFtcIiRzY29wZVwiLCBcIiR1aWJNb2RhbFwiXTtcblxubW9kdWxlLmV4cG9ydHMgPSBBY2NvdW50Q29udHJvbGxlcjsiXX0=